import script from "./ImageCompressor.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCompressor.vue?vue&type=script&setup=true&lang=js"

import "./ImageCompressor.vue?vue&type=style&index=0&id=20bbd1ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bbd1ea"]])

export default __exports__